<!--==============================
=            CONTACTS            =
===============================-->

<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Contacts</div>
      </base-header>
    </v-row>
    <v-row no-gutters>
      <v-col v-for="n in items" :key="n" cols="12" sm="12" md="4">
        <v-card class="pa-3 ma-3 elevation-2">
          <div class="media p-3 align-items-center">
            <img :src="n.img" alt="user" class="rounded-circle thumb-xl" />
            <div class="media-body ml-3 align-self-center">
              <h5 class="pro-title subtitle-1">{{n.name}}</h5>
              <p class="mb-2 text-muted subtitle-2">{{n.rank}}</p>
              <ul class="list-inline list-unstyled profile-socials mb-0">
                <li class="list-inline-item">
                  <a href="#" class>
                    <i class="fab fa-facebook-f info--text"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href="#" class>
                    <i class="fab fa-twitter blue--text"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href="#" class>
                    <i class="fab fa-dribbble pink--text"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data() {
    return {
      items: [
        {
          name: "Camila smith ",
          rank: "SEO",
          color: "pink",
          img: "https://bootdey.com/img/Content/avatar/avatar7.png"
        },
        {
          name: "Valery Lopes",
          rank: "ADM",
          img: "https://bootdey.com/img/Content/avatar/avatar1.png"
        },
        {
          name: "Samira Avelar",
          rank: "ADM",
          img: "https://bootdey.com/img/Content/avatar/avatar3.png"
        },
        {
          name: "Derick Jhnoes",
          rank: "SEO",
          img: "https://bootdey.com/img/Content/avatar/avatar4.png"
        },
        {
          name: " Smith Jonh",
          rank: "ADM",
          img: "https://bootdey.com/img/Content/avatar/avatar3.png"
        },
        {
          name: "Diane Zuckerberng",
          rank: "ADM",
          img: "https://bootdey.com/img/Content/avatar/avatar5.png"
        },
        {
          name: "Vinicius Jhoimhhg",
          rank: "SEO",
          img: "https://bootdey.com/img/Content/avatar/avatar2.png"
        },
        {
          name: "Stefany",
          rank: "ADM",
          img: "https://bootdey.com/img/Content/avatar/avatar3.png"
        },
        {
          name: "Peter Jones",
          rank: "ADM",
          img: "https://bootdey.com/img/Content/avatar/avatar7.png"
        },
        {
          name: "Caio Thomson ",
          rank: "SEO",
          img: "https://bootdey.com/img/Content/avatar/avatar6.png"
        },
        {
          name: "Debora wilson",
          rank: "ADM",
          img: "https://bootdey.com/img/Content/avatar/avatar5.png"
        },
        {
          name: "Stones Swiths",
          rank: "ADM",
          img: "https://bootdey.com/img/Content/avatar/avatar4.png"
        }
      ]
    };
  }
};
</script>
<style scoped>
</style>


<!--====  End of CONTACTS  ====-->
